import '../styles/index.scss';
import dict_s from '../scripts/sum_dict';
import dict_t from '../scripts/tit_dict';
import {lemmatizer} from "lemmatizer";
import * as tf from '@tensorflow/tfjs';
import { input } from '@tensorflow/tfjs';

var model;


function text_cleaner(original_text){
    var cleaned_text = original_text.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,""); // Remove punctuation
    cleaned_text = cleaned_text.replace(/\s{2,}/g," ");
    cleaned_text = cleaned_text.toLowerCase(); // Convert to lowercase
    cleaned_text = cleaned_text.replace(/(\r\n\t|\n|\r\t)/gm, ""); // Remove newlines
    cleaned_text = cleaned_text.replace(/\d/g,''); // Remove digits
    cleaned_text = cleaned_text.split(' '); // Split each sentence using delimiter

    var lemmatized_list = [];
    let z;
    for (let y in cleaned_text){ // Looks at every word in list
        if (cleaned_text[y] !== ""){ // Skips every blank
            z=lemmatizer(cleaned_text[y]); 
            lemmatized_list.push(z);
        }
    }
    return lemmatized_list;
}


function sumword_to_int(word_list){
  
    const MAXLEN = 300;
  
    var tokenized_sum = Array(MAXLEN).fill(0);
  
    var input_list = text_cleaner(word_list);
    var word_to_int = [];
  
    for (let word in input_list){
        if(dict_s[input_list[word]]){
            word_to_int.push(dict_s[input_list[word]]); 
        } 
    } 
  
    tokenized_sum.length = tokenized_sum.length-word_to_int.length;
    const sum_result = tokenized_sum.concat(word_to_int);
    return sum_result;
  }

// console.log(sumword_to_int("The study will investigate the effect of personalized diet on blood glucose control in individuals with diabetes as compared with ADA diet."));

function titword_to_int(word_list){
  
    const MAXLEN = 300;
  
    var tokenized_tit = Array(MAXLEN).fill(0);
  
    var input_list = text_cleaner(word_list);
    var word_to_int = [];
  
    for (let word in input_list){
        if(dict_t[input_list[word]]){
            word_to_int.push(dict_t[input_list[word]]); 
        } 
    } 
  
    tokenized_tit.length = tokenized_tit.length-word_to_int.length;
    const tit_result = tokenized_tit.concat(word_to_int);
    return tit_result;
  }

// console.log(titword_to_int("Personalized Nutrition. for. Diabetes Type 2"));

function ready_for_model(Title, Summary){

    var X_pred_sum = [sumword_to_int(Summary)];
    var X_pred_tit = [titword_to_int(Title)];
    
    return [
        X_pred_sum, X_pred_tit
    ];
}


async function loadingModel() {
    return new Promise (
        (resolve, reject) => {
            tf.loadModel('./public/model.json')
            .then(function (res) {
                resolve(res); 
            })
            .catch(function (error) {
                reject(error);
            });
        }
    );
};

function readyDom() {
    (async () => {
        model = await loadingModel();
        // 
        console.log('yo')
        document.getElementById('app').classList.add('initialized');
    })();
    document.getElementById("button").addEventListener("click", function(){
        compute_data();
    });

};



function generate_table(MyArray){
    var table = document.getElementById("table");
        // rows
    for(var i = 0; i < 4; i++)
    {
            table.rows[1].cells[i].innerHTML = MyArray[i].toFixed(2)*100 + "%";
    }
}

function compute_data(){
    var sum_text = document.getElementById("summary").value;
    var tit_text = document.getElementById("title").value;
    var result = ready_for_model(sum_text, tit_text);
    var tit_input = tf.tensor(result[0]);
    var sum_input = tf.tensor(result[1]);
    var Predictions = model.predict([sum_input,tit_input])
    const values = Predictions.dataSync();
    const arr = Array.from(values);
    generate_table(arr);
}



document.addEventListener('DOMContentLoaded', readyDom, false);